import React, { useEffect } from "react"
import Layout from "../components/layout/Layout";
import {
    useSearchParams
} from 'react-router-dom';
import ReactLoading from 'react-loading';

const Redirect = () => {

    const [queryParameters] = useSearchParams();

    useEffect(() => {

        var url = queryParameters.get("redirect_url");

        window.location.replace(`${url}`);
    
    }, [queryParameters.get("redirect")])

    return (
        <Layout>
            <div className="w-full px-4 md:px-32 bg-white my-32 w-auto flex flex-row items-center">

                <h1 className="order-1 text-2xl my-4 md:text-3xl text-gray-500 font-bold ml-4">Wait for redirection </h1>
                
                <div>
                    <ReactLoading type={"spin"} color={"#0047BA"} height={50} width={50} />
                </div>

            </div>
        </Layout>
    )
}

export default Redirect
